import React from "react";
import "./styles.scss";

const Zone = ({ className, shots = {} }) => {
  const { z1 = 0, z2 = 0, z3 = 0, z4 = 0, z5 = 0 } = shots;

  const getOpacityClass = (count) => {
    if (count <= 2) return "opacity-0";
    const level = Math.min(10, Math.ceil(count));
    return `opacity-${level}`;
  };

  return (
    <div className={`bild-hotzone-container ${className}`}>
      <div
        className={`hotzone-block hotzone-end-block ${getOpacityClass(z1)} ${
          z1 > 2 ? "shots-zone" : ""
        }`}
      >
        {z1 > 2 && <span>{z1}</span>}
      </div>
      <div className="hotzone-block hotzone-inner-block">
        <div
          className={`hotzone-mid-block ${getOpacityClass(z2)} ${
            z2 > 2 ? "shots-zone" : ""
          }`}
        >
          {z2 > 2 && <span>{z2}</span>}
        </div>

        <div
          className={`hotzone-mid-block ${getOpacityClass(z3)} ${
            z3 > 2 ? "shots-zone" : ""
          }`}
        >
          {z3 > 2 && <span>{z3}</span>}
        </div>

        <div
          className={`hotzone-mid-block ${getOpacityClass(z4)} ${
            z4 > 2 ? "shots-zone" : ""
          }`}
        >
          {z4 > 2 && <span>{z4}</span>}
        </div>
      </div>

      <div
        className={`hotzone-block hotzone-end-block ${getOpacityClass(z5)} ${
          z5 > 2 ? "shots-zone" : ""
        }`}
      >
        {z5 > 2 && <span>{z5}</span>}
      </div>
    </div>
  );
};

export default Zone;
